import React from "react";
import { Router, Route } from "react-router-dom";
import Landing from "./containers/landing/Landing";
import Header from "./components/Header/Header";
import { createBrowserHistory as createHistory } from "history";
import queryString from 'query-string';
import "./App.css";

const history = createHistory();

function App() {
  return (
    <div className="App">
      <Router history={history}>
        <Route
          path="/"
          exact
          component={(props: any) => {
            const parsed = queryString.parse(props.location.search);
            const standaloneHeader: boolean = parsed.standaloneHeader ? (parsed.standaloneHeader ? true : false) : false;
            if (standaloneHeader) {
              return (<Header {...props} />);
            } else {
              return (<Landing {...props} />); 
            }
          }}
        />
      </Router>
    </div>
  );
}
export default App;
